// Lifted from variables.config.js
export const DELIVERY_TYPE = { COD: 'COD', PREPAID: 'PREPAID' } as const;
export const LR_GENERATE_TYPE = { '1': 'Automatic', '2': 'Manual' } as const;
export const PICKUP_TYPE = { '1': 'FM-Pickup', '2': 'Self-Drop' } as const;
export const INSURANCE_TYPE = { '1': 'Carrier Risk', '2': 'Owner Risks' } as const;
export const FREIGHT_COLLECTION_TYPE = { '1': 'Bill to Client', '2': 'Collect on Delivery (COD)' } as const;
export const BOOKING_TYPE = { FORWARD: 'Forward', REVERSE: 'Reverse', EXCHANGE: 'Exchange' } as const;
export const SERVICE = { '1': 'Air', '2': 'Prime', '3': 'Surface' } as const;
export const IS_FRAGILE = { Yes: 'Yes', No: 'No' } as const;

// Status code -> label — the full 33-status master so a status never renders as a raw number.
export const STATUS_LABEL: Record<number, string> = {
  1: 'Booking received', 2: 'Pickup Schedule', 3: 'Picked', 4: 'At Branch/Warehouse',
  5: 'In Transit', 6: 'Arrived at Destination', 7: 'Out for Delivery', 8: 'Delivered',
  9: 'Delivery Failed', 10: 'RTO In Transit', 11: 'RTO at Branch', 12: 'RTO Delivered',
  13: 'LOST', 14: 'RTO LOST', 15: 'Forward Damage', 16: 'RTO Damage', 17: 'Held Up',
  18: 'RTO Pending', 19: 'Partially Delivered', 20: 'Booking Pending', 21: 'Booking Failed',
  23: 'Cancelled', 24: 'Not Shipped',
  25: 'Received at Noida Branch', 26: 'Wrong Book', 27: 'Shipment Left for Lucknow',
  28: 'Received at Kolkata Branch', 29: 'Received at Lucknow Branch',
  30: 'Shipment Left for Next Facility Noida', 32: 'Shipment Left for Next Facility',
  33: 'Auto Cancelled',
};

export const STATUS_COLOR: Record<number, string> = {
  8: 'bg-green-50 text-green-700 border-green-200',
  24: 'bg-amber-50 text-amber-700 border-amber-200',
  21: 'bg-red-50 text-red-700 border-red-200',
  23: 'bg-slate-100 text-slate-600 border-slate-200',
  9: 'bg-red-50 text-red-700 border-red-200',
  1: 'bg-blue-50 text-blue-700 border-blue-200',
  5: 'bg-blue-50 text-blue-700 border-blue-200',
  7: 'bg-violet-50 text-violet-700 border-violet-200',
};

export const B2C_TABS = [
  { id: 'not-shipped', label: 'Not Shipped' },
  { id: 'today-uploads', label: 'Today Uploads' },
  { id: 'ndr', label: 'NDR' },
  { id: 'in-transit', label: 'In Transit' },
  { id: 'delivered', label: 'Delivered' },
  { id: 'ofd', label: 'OFD' },
  { id: 'returned', label: 'Returned to Seller' },
  { id: 'booking-failed', label: 'Booking Failed' },
  { id: 'cancelled', label: 'Cancelled' },
  { id: 'all-shipped', label: 'All Shipped Orders' },
] as const;

export const B2B_TABS = [
  // Today Uploads stays FIRST so the B2B landing tab doesn't move.
  { id: 'today-uploads', label: 'Today Uploads' },
  // B2B never had a "Not Shipped" tab — an uploaded-but-unbooked B2B order was only ever visible
  // because "Today Uploads" listed everything created today. Now that Today Uploads is shipped-only
  // (matching B2C, and what the tab claims to be), those rows need the same home B2C gives them.
  { id: 'not-shipped', label: 'Not Shipped' },
  { id: 'ndr', label: 'NDR' },
  { id: 'in-transit', label: 'In Transit' },
  { id: 'delivered', label: 'Delivered' },
  { id: 'ofd', label: 'OFD' },
  { id: 'returned', label: 'Returned to Seller' },
  { id: 'booking-failed', label: 'Booking Failed' },
  { id: 'cancelled', label: 'Cancelled' },
  { id: 'all-shipped', label: 'All Shipped Orders' },
] as const;

// Status ids that make up the "All Shipped Orders" tab (mirrors backend ALL_SHIPPED_STATUSES).
// Used to build the searchable multi-status filter on that tab.
export const ALL_SHIPPED_STATUS_IDS = [1,2,3,4,5,6,7,8,10,11,12,14,15,16,17,18,19,25,26,27,28,29,30,32];

export type OrderType = 'B2C' | 'B2B';
